<template>
    <div>
		<div style="margin-left: 300px;">
			<b>进件详情</b>
		</div>
        <div class="modal_flex">
            <div class="item_box">
                <div class="title_box"></span>邀约客户经理：</div>
				<span style="width: 250px;">{{loan_data.add_name}}</span>
            </div>
			<div class="item_box">
			    <div class="title_box"></span>谈单客户经理：</div>
				<span style="width: 250px;">{{loan_data.assist_uid_name}}</span>
			</div>
        </div>
        <div class="modal_flex">
			<div class="item_box">
			    <div class="title_box"></span>后勤客户经理：</div>
				<span style="width: 250px;">{{loan_data.principal_uid_name}}</span>
			</div>
            <div class="item_box">
                <div class="title_box"></span>资方对接人：</div>
				<span style="width: 250px;">{{loan_data.manager}}</span>
            </div>
        </div>
		<div class="modal_flex">
		    <div class="item_box">
		        <div class="title_box"></span>进件状态：</div>
		        <span style="width: 250px;">{{loan_data.status}}</span>
		    </div>
		    <div class="item_box">
		        <div class="title_box"></span>财务审核状态：</div>
				<span style="width: 250px;">{{loan_data.check_status}}</span>
		    </div>
		</div>
        <div class="modal_flex">
            <div class="item_box">
                <div class="title_box"></span>进件日期：</div>
				<span style="width: 250px;">{{loan_data.join_at}}</span>
            </div>
			<div class="item_box">
			    <div class="title_box"></span>进件渠道：</div>
			    <span style="width: 250px;">{{loan_data.product_id}}</span>
			</div>
        </div>
		<div class="modal_flex">
		    <div class="item_box">
		        <div class="title_box"></span>进件额度：</div>
		        <span style="width: 250px;">{{loan_data.loans_money}}</span>
		    </div>
		    <div class="item_box">
		        <div class="title_box"></span>批款额度：</div>
				<span style="width: 250px;">{{loan_data.get_money}}</span>
		    </div>
		</div>
		<div class="modal_flex">
		    <div class="item_box">
		        <div class="title_box"></span>放款日期：</div>
		        <span style="width: 250px;">{{loan_data.repay_at}}</span>
		    </div>
		</div>
		<div style="margin-left: 300px;">
			<b>费用详情</b>
		</div>
		<div class="modal_flex">

			<div class="item_box">
			    <div class="title_box"></span>公司净收入：</div>
			    <span style="width: 250px;">{{loan_data.repay_money}}</span>
			</div>
		</div>
		<div class="modal_flex">
		    <div class="item_box">
		        <div class="title_box"></span>邀约业绩：</div>
		        <span style="width: 250px;">{{loan_data.repay_money - loan_data.assist_money}}</span>
		    </div>
		    <div class="item_box">
		        <div class="title_box"></span>谈单业绩：</div>
				<span style="width: 250px;">{{loan_data.assist_money}}</span>
		    </div>
		</div>
		<div class="modal_flex">
		    <div class="item_box">
		        <div class="title_box"></span>后勤费用：</div>
				<span style="width: 250px;">{{loan_data.channel_fee}}</span>
		    </div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
			    <div class="title_box"></span>创建时间：</div>
				<span style="width: 250px;">{{loan_data.created_at}}</span>
			</div>
		</div>
    </div>
</template>

<script>
    import MyUpload from '../tool/Upload.vue'
    import {
        getClientRecord
    } from '@/api/client'
    import {
        getLoan,saveLoan,getDetailLoan
    } from '@/api/task'
    import {mapActions, mapGetters} from "vuex";
    import {getAllOrganization, getAllProduct} from "../../api/runSet";

    export default {
        name: "LoanDetail",
        components: {MyUpload},
        props: ['loanId', 'clientId', 'contractId', 'userList'],
        computed: {
            ...mapGetters(['token']),
        },
		watch: {
			loanId() {
				this.loadData();
			}
		},
        data() {
            return {
                client: [],
                organizationList: [],
                productList: [],
				loan_data:[],
                formItem: {
                    join_at: '无',
                    manager: '',
                    organization_id: 0,
                    product_id: 0,
                    principal_uid: 0,
                    rate: '',
                    get_money: '',
                    loans_money: '',
                    monthly_payment: '',
                    periods: '',
                    status: '',
                    repay_at: '',
                    repay_money: '',
                    channel_fee: '',
					sincrtity_status:"",
                }
            }
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            async loadData() {
                let that = this;
                let data = {token: that.token};
                if (that.loanId != 0) {
                    let data = {token: that.token, id: that.loanId}
                    let res = await getDetailLoan(that, data);
					console.log(res)
                    if (res.code == 1) {
                        that.loan_data = res.data.item;
                    }
                } else {
                    that.initForm();
                }
            },
            initForm() {
                this.formItem = {
                    join_at: '无',
                    manager: '',
                    organization_id: 0,
                    product_id: 0,
                    principal_uid: 0,
                    rate: '',
                    get_money: '',
                    loans_money: '',
                    monthly_payment: '',
                    periods: '',
                    status: '',
                    repay_at: '',
                    repay_money: '',
                    channel_fee: '',
                };
            },
            save() {
                var that = this;
				if(that.formItem.status ==9 || that.formItem.status ==11 ||that.formItem.status ==13){
					var title = "确定保存并提交给财务审核吗？";
				}else{
					var title = "确定保存吗？";
				}				
				this.$Modal.confirm({
				    title: title,
				    onOk: async () => {
                    let data = {token: that.token, data: that.formItem, client_id: that.clientId, contract_id: that.contractId};
                    let res = await saveLoan(that, data);
                    if (res.code == 1) {
                        that.$Message.success(res.msg);
                        that.initForm();
                        that.$emit('reloadData');
                    }
				    }
				})
            }
        }
    }
</script>

<style scoped lang="less">
    .icon-bixuan {
        color: red;
    }

    .title_css {
        width: 86px;
        text-align: right;
        margin-right: 10px;
    }

    .list_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    .modal_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;
		padding-left: 50px;

        .item_box {
            width: auto;
            display: flex;
            align-items: center;

            .btn {
                margin: 0 10px;
            }

            .title_box {
                width: 130px;
                text-align: right;
            }
        }

        .icon-bixuan {
            color: #FE485B;
        }
    }
</style>
